import React, {VoidFunctionComponent} from "react";

interface Props {
    field?: string,
    value?: string,
    callback: (value: string, field?: string) => void,
    label?: string,
    topMessage?: string,
    bottomMessage?: string | boolean,
    placeholder?: string,
    disabled?: boolean,
    readOnly?: boolean,
    error?: boolean,
}

export const TextArea: VoidFunctionComponent<Props> = ({
                                                           field,
                                                           value,
                                                           callback,
                                                           label,
                                                           topMessage,
                                                           bottomMessage,
                                                           placeholder,
                                                           disabled,
                                                           readOnly,
                                                           error,
                                                       }) => {
    return (
        <div className={`textArea ${error ? 'error' : ''}`}>
            {label && <label className={"label"}>{label}</label>}
            {topMessage && <span className={"topMessage"}>{topMessage}</span>}
            <div className="textarea-wrapper">
        <textarea
            value={value}
            disabled={disabled}
            readOnly={readOnly}
            placeholder={placeholder}
            onChange={(e) => callback(e.target.value, field)}
        />
            </div>
            {bottomMessage && <span className={"bottomMessage"}>{bottomMessage}</span>}
        </div>
    )
};